// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Oi2q","rootNoMargin":"styles_rootNoMargin__1Kb49"};